/* eslint-disable react/destructuring-assignment */
import { Alert, Burger, Group } from '@mantine/core';
import { IconSandbox } from '@tabler/icons-react';
import Menu from './Menu/Menu';

type HeaderProps = {
  mobileOpened: boolean;
  toggleMobile: any;
  desktopOpened: boolean;
  toggleDesktop: any;
};

function Header(props: HeaderProps) {
  const environment = process.env.REACT_APP_CUSTOM_NODE_ENV || process.env.NODE_ENV;

  return (
    <Group h="100%" px="md" justify="space-between">
      <Group>
        <Burger opened={props.mobileOpened} onClick={props.toggleMobile} hiddenFrom="sm" size="sm" />
        <Burger opened={props.desktopOpened} onClick={props.toggleDesktop} visibleFrom="sm" size="sm" />
        {environment !== 'production' && (
          <Alert icon={<IconSandbox size={20} />} color="orange" p="xs">
            {environment}
          </Alert>
        )}
      </Group>
      <Menu />
    </Group>
  );
}

export default Header;
